export enum ECardProgressSize {
    BASE = 'base',
    LARGE = 'large'
}

export interface ICardProgressFields {
    backgroundColor?: string;
    canDone?: boolean;
    isButton?: boolean;
    isColumnView?: boolean;
    isLightBgStroke?: boolean;
    isReadonly?: boolean;
    progress: number;
    size: ECardProgressSize;
    tooltip: string;
}

export interface ICardProgressEvents {
    onClick?: () => Promise<any>;
    onShowBoardLimitSnackbarIfNeeded?: () => void;
}

export interface ICardProgressProps extends
    ICardProgressFields,
    ICardProgressEvents
{}
